
const apiProxy = require('./apiProxy.js');
const stateManager = require('../../utils/state/stateManager.js');
const stringUtil = require('../../utils/string/stringUtil');
const constants = require('../../utils/domain/constants');
const basketUtil = require('../../utils/basket/basketUtil');

export async function updateApplicationConfiguration()
{
    return apiProxy.get(`application`)
            .then(response=>
            {
                updateStateWithResponse(response);
                return Promise.resolve(true);
            }, error =>
            {
                return Promise.reject(error);
            });
}

function updateStateWithResponse(response)
{
    var state = stateManager.getStore().getState();

    state.applicationId = response.applicationId;
    state.applicationTitle = response.title;
    state.franchisor = response.franchisor;
    state.franchisorId = response.franchisorId;
    state.franchisee = response.franchisee;
    state.franchiseeId = response.franchiseeId;
    state.property = response.property;
    state.propertyId = response.propertyId;
    state.resolvedLocalizationSettings = response.resolvedLocalizationSettings;
    state.tableNumber = response.tableNumber;
    state.themeId = response.themeId;
    state.favIconUrl = response.favIconUrl;

    state.venueCode = response.venueCode;
    state.channel = response.channel;
    state.allowedDispatchTypes = response.allowedDispatchTypes;
    state.saleMenuId = response.saleMenuId;
    state.rewardMenuId = response.rewardMenuId;
    state.priceBandId = response.priceBandId;
    
    state.storefront = response.storefront;
    state.emailReplyToAddress = response.emailReplyToAddress;

    state.doesSupportMultipleProperties = false;
    if (stringUtil.isStringNullOrEmpty(response.propertyId))
    {
        state.doesSupportMultipleProperties = true;
        state.tableNumber = null;
    }

    state.onlinePaymentConfiguration = response.onlinePaymentConfiguration;

    basketUtil.resetBasket();

    if(response.sale)
    {
        const sale = response.sale;
        var basket = stateManager.getStore().getState().basket;
        basket.order.id = sale.id;
        basket.order.number = sale.number
        basket.order.saleItems = sale.saleItems;
        basket.order.dispatchType = sale.dispatchType;
        basket.order.paidAmount = sale.paidAmount;
        basket.order.instructions = sale.instructions;
        basket.order.saleType = sale.saleType;
        basket.order.channel = sale.channel;
        basket.order.venueCode = sale.venueCode;
        basket.order.customerId = sale.customerId;
        basket.order.lastUpdatedDateTime = sale.lastUpdatedDateTime;
        basket.order.paymentMethod = constants.paymentMethods.credit;
        basket.dispatchInfo = JSON.parse(sale.dispatchInfo);
        basket.isPaymentOverPhoneApplicableToSale = basketUtil.isPaymentOverPhoneApplicableToSale(sale);

        basket.order.charges = sale.charges;
        basket.order.discounts = sale.discounts;
    }        
}
